import { Box, Grid, Typography, Link, Divider, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import "./Footer.scss";
import endpoints from "helpers/endpoints";

function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <Box bgcolor="tertiary.main">
      <Container maxWidth="xl" disableGutters>
        <Box display="flex" className="footer">
          <Typography
            align="center"
            sx={{
              width: "100%",
              marginLeft: 20,
              marginTop: 1,
              marginBottom: 1,
              fontSize: 10,
              "@media screen and (max-width: 1200px)": {
                fontSize: "7px"
              }
            }}
            color="secondary.main"
            variant="caption"
          >
            {t("footer.title", { year: currentYear })}
          </Typography>

          <Grid container sx={{ width: 400 }}>
            <Grid item xs>
              <Link
                href={endpoints.TermsAndConditions}
                target="_blank"
                color="secondary"
              >
                <Typography
                  align="right"
                  sx={{ marginRight: 1 }}
                  variant="subtitle1"
                >
                  {t("footer.tnc")}
                </Typography>
              </Link>
            </Grid>
            <Grid item>
              <Divider
                orientation="vertical"
                color="secondary.main"
                sx={{ width: 1 }}
              />
            </Grid>
            <Grid item>
              <Typography align="right" sx={{ marginRight: 1 }}></Typography>
            </Grid>
            <Grid item xs>
              <Link
                href={endpoints.PrivacyPolicy}
                target="_blank"
                color="secondary"
              >
                <Typography align="left" variant="subtitle1">
                  {t("footer.privacyPolicy")}
                </Typography>
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
